<template>
  <div class="test">
    <el-carousel indicator-position="outside">
      <el-carousel-item v-for="(item, k) in dataList" v-if="k % 4 === 0">
        <div class="imgBar">
          <div class="imgNavs clear">
            <div
              class="imgNav left"
              v-for="(currect, i) in dataList.slice(k)"
              v-if="i < 4"
            >
              <img :src="currect.imgPath3" />
              <div class="striping">
                <p class="p1">{{ currect.title }}</p>
                <p class="p2">{{ currect.name }}</p>
              </div>
            </div>
          </div>
        </div>
      </el-carousel-item>
    </el-carousel>
  </div>
</template>

<script>
export default {
  name: "test",
  props: ["dataList"],
  data() {
    return {
      // dataList: [],
      num: 0
    };
  },
  method: {}
};
</script>

<style>
.test {
  /* padding-bottom: 40px; */
}

.test .imgBar {
  width: 100%;
  /* 
		margin-top: 80px; */
}

.test .imgNavs {
  width: 85%;
  margin: 0 auto;
}

.test .imgNavs .imgNav {
  width: 25%;
  margin: 0 auto;
}

.test .imgNav img {
  width: 60%;
  margin: 0 auto;
  margin-left: 47px;
  padding-bottom: 30px;
  border-bottom: 1px solid #c4c4c4;
}

.test .el-carousel__container {
  width: 90%;
  height: 400px;
  margin: 0 auto;
}

.test .el-carousel__arrow {
  background-color: rgba(31, 45, 61, -0.89);
  color: #ccb356;
  top: 30%;
}

.test .el-carousel__arrow:hover {
  background-color: rgba(31, 45, 61, -0.89);
  color: #ccb356;
}

.test .el-carousel__arrow--left {
  margin-left: 0;
}

.test .el-carousel__arrow--right {
  margin-right: 0;
}

.test .el-icon-arrow-left {
  font-size: 36px;
  margin-left: 40px;
  outline: none;
}

button:focus {
  outline: none;
}

.test .el-icon-arrow-right {
  font-size: 36px;
  margin-left: -70px;
  outline: none;
}

.test .el-carousel__indicators--outside {
  display: none;
}

.test .striping {
  /* border-top: 1px solid #C4C4C4; */
  width: 60%;
  margin: 0 auto;
  /* margin-top: 35px; */
}

.test .striping p {
  text-align: center;
  color: #595757;
  margin-bottom: 0;
}

.test .striping .p1 {
  font-size: 10px;
  margin-top: 10px;
  letter-spacing: 0.3px;
}

.test .striping .p2 {
  margin-top: 5px;
  font-size: 16px;
}

/* 媒体查询 */
@media screen and (max-width: 1300px) {
  .test .el-carousel__container {
    height: 300px;
  }
}

@media screen and (mix-width: 1400px) {
  .test .imgNav img {
    margin-left: 75px;
  }
}
</style>
